import React from 'react';
import Icon from '../AppIcon';

const WizardProgress = ({ 
  currentStep = 1, 
  totalSteps = 3, 
  steps = [],
  onStepChange = null 
}) => {
  const defaultSteps = [
    { label: 'Informations', labelEn: 'Information', completed: false },
    { label: 'Finances', labelEn: 'Finances', completed: false },
    { label: 'Résultats', labelEn: 'Results', completed: false }
  ];

  const wizardSteps = steps?.length > 0 ? steps : defaultSteps?.slice(0, totalSteps);

  const handleStepClick = (stepIndex) => {
    if (onStepChange && stepIndex < currentStep) {
      onStepChange(stepIndex + 1);
    }
  };

  const isStepCompleted = (stepIndex) => {
    return stepIndex < currentStep - 1 || wizardSteps?.[stepIndex]?.completed;
  };

  const isStepActive = (stepIndex) => {
    return stepIndex === currentStep - 1;
  };

  return (
    <div className="wizard-progress">
      {wizardSteps?.map((step, index) => (
        <React.Fragment key={index}>
          <div
            className={`wizard-progress-step ${
              isStepActive(index) ? 'active' : ''
            } ${isStepCompleted(index) ? 'completed' : ''}`}
            onClick={() => handleStepClick(index)}
            style={{ cursor: index < currentStep - 1 ? 'pointer' : 'default' }}
          >
            <div className="wizard-progress-step-number">
              {isStepCompleted(index) ? (
                <Icon name="Check" size={16} />
              ) : (
                <span>{index + 1}</span>
              )}
            </div>
            <span className="wizard-progress-step-label">
              {step?.label}
            </span>
          </div>
          {index < wizardSteps?.length - 1 && (
            <div
              className={`wizard-progress-connector ${
                isStepCompleted(index) ? 'completed' : ''
              }`}
            />
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default WizardProgress;